import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_2 = { class: "ms-2 flex-fill" }
const _hoisted_3 = {
  key: 0,
  class: "text-warning text-label mb-0 mt-1 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_5 = { class: "text-subtitle mb-0" }
const _hoisted_6 = {
  key: 2,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_7 = {
  key: 1,
  class: "text-subtitle mb-0"
}
const _hoisted_8 = { class: "text-paragraph" }
const _hoisted_9 = { class: "d-flex py-4 align-items-center justify-content-between border-bottom" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Período", -1)
const _hoisted_11 = { class: "text-subtitle mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.item.status == _ctx.appointmentStatus.AGUARDANDO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Button, {
            marginVertical: false,
            fullWidth: "",
            onOnClick: _ctx.handleCancelPressed,
            label: "Cancelar",
            outline: "",
            outlineColor: "danger",
            loading: _ctx.isSubmittingCancel,
            class: "me-2"
          }, null, 8, ["onOnClick", "loading"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              marginVertical: false,
              fullWidth: "",
              onOnClick: _ctx.handleAccept,
              label: "Aceitar sessão",
              loading: _ctx.isSubmittingConfirm,
              disabled: _ctx.item.payment_requires_action
            }, null, 8, ["onOnClick", "loading", "disabled"]),
            (_ctx.item.payment_requires_action)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Aguardando autenticação do pagamento pelo paciente "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (
      _ctx.item.status == _ctx.appointmentStatus.AGENDADO ||
      _ctx.item.status == _ctx.appointmentStatus.ANDAMENTO
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.item?.status == _ctx.appointmentStatus.ANDAMENTO
          ? `Sessão iniciada`
          : `Aguardando início`), 1),
          _createVNode(_component_Button, {
            marginVertical: false,
            onOnClick: _ctx.handleScheduledAppointment,
            label: "Iniciar sessão",
            disabled: !_ctx.item?.can_enter,
            loading: _ctx.isSubmittingConfirm
          }, null, 8, ["onOnClick", "disabled", "loading"])
        ]))
      : _createCommentVNode("", true),
    (
      _ctx.item?.type == _ctx.appointmentTypes.IMEDIATE &&
      (_ctx.item?.status == _ctx.appointmentStatus.ANDAMENTO ||
        _ctx.item?.status == _ctx.appointmentStatus.PENDING)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.item.status == _ctx.appointmentStatus.PENDING)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                marginVertical: false,
                fullWidth: "",
                outline: "",
                class: "me-2",
                onOnClick: _ctx.handleCancelPressed,
                loading: _ctx.isSubmittingCancel,
                label: "Recusar"
              }, null, 8, ["onOnClick", "loading"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, "Sessão iniciada")),
          _createVNode(_component_Button, {
            marginVertical: false,
            fullWidth: _ctx.item.status == _ctx.appointmentStatus.PENDING,
            class: _normalizeClass({ 'ms-2': _ctx.item.status == _ctx.appointmentStatus.PENDING }),
            label: 
        _ctx.item.status == _ctx.appointmentStatus.PENDING
          ? 'Iniciar sessão'
          : 'Retomar sessão'
      ,
            loading: _ctx.comingIn,
            disabled: !_ctx.item.can_enter,
            onOnClick: _ctx.handleScheduledAppointment
          }, null, 8, ["fullWidth", "class", "label", "loading", "disabled", "onOnClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalComponent, {
      backdrop: "false",
      id: _ctx.modalId,
      title: "Deseja aceitar esta sessão e as futuras?"
    }, {
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_8, " Aceitando essa sessão você estará aceitando sessões que acontecerão " + _toDisplayString(_ctx.item?.recurrency?.frequencyText), 1),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.item?.recurrency?.frequencyLabel), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          outline: "",
          label: "Não, voltar",
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(_ctx.modalId)))
        }),
        _createVNode(_component_Button, {
          label: "Aceitar esta e as próximas sessões",
          onOnClick: _ctx.handleConfirmPressed,
          loading: _ctx.isSubmittingConfirm
        }, null, 8, ["onOnClick", "loading"])
      ]),
      _: 1
    }, 8, ["id"])
  ], 64))
}